import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitPerformanceFinSwimResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitFinSwimResultInput;
}>;


export type SubmitPerformanceFinSwimResultMutation = (
  { __typename: 'Mutation' }
  & { submitFinSwimResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitFinSwimResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'PerformanceResult' }
      & FinSwimPerformanceResultFragment
    )> }
  ) }
);

export type FinSwimPerformanceResultFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | (
    { __typename: 'FinSwimResult' }
    & FinSwimPerformanceResultDataFragment
  ) | { __typename: 'IpptResult' } | { __typename: 'March20kmResult' } | { __typename: 'SocResult' } | { __typename: 'WeightResult' } }
);

export type FinSwimPerformanceResultDataFragment = (
  { __typename: 'FinSwimResult' }
  & Pick<SchemaTypes.FinSwimResult, 'timingSec'>
);

export const FinSwimPerformanceResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment FinSwimPerformanceResultData on FinSwimResult {
  timingSec
}
    `;
export const FinSwimPerformanceResultFragmentDoc = /*#__PURE__*/ gql`
    fragment FinSwimPerformanceResult on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on FinSwimResult {
      ...FinSwimPerformanceResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitPerformanceFinSwimResultDocument = /*#__PURE__*/ gql`
    mutation SubmitPerformanceFinSwimResult($input: SubmitFinSwimResultInput!) {
  submitFinSwimResult(input: $input) {
    ... on SubmitFinSwimResultSuccessfulResponse {
      result {
        ...FinSwimPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${FinSwimPerformanceResultFragmentDoc}
${FinSwimPerformanceResultDataFragmentDoc}`;
export type SubmitPerformanceFinSwimResultMutationFn = Apollo.MutationFunction<SubmitPerformanceFinSwimResultMutation, SubmitPerformanceFinSwimResultMutationVariables>;

/**
 * __useSubmitPerformanceFinSwimResultMutation__
 *
 * To run a mutation, you first call `useSubmitPerformanceFinSwimResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPerformanceFinSwimResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPerformanceFinSwimResultMutation, { data, loading, error }] = useSubmitPerformanceFinSwimResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPerformanceFinSwimResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPerformanceFinSwimResultMutation, SubmitPerformanceFinSwimResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPerformanceFinSwimResultMutation, SubmitPerformanceFinSwimResultMutationVariables>(SubmitPerformanceFinSwimResultDocument, options);
      }
export type SubmitPerformanceFinSwimResultMutationHookResult = ReturnType<typeof useSubmitPerformanceFinSwimResultMutation>;
export type SubmitPerformanceFinSwimResultMutationResult = Apollo.MutationResult<SubmitPerformanceFinSwimResultMutation>;
export type SubmitPerformanceFinSwimResultMutationOptions = Apollo.BaseMutationOptions<SubmitPerformanceFinSwimResultMutation, SubmitPerformanceFinSwimResultMutationVariables>;